import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * A module's retired Threats page (2026-10-17): its links and bookmarks land on the module's
 * Security Signals view, scoped to the same surface - the count Security Atlas and the module
 * dashboard show, mutes honoured. `?severity=` carries over as Signals' `?sev=`; the old page's
 * `?threat=` / `?tab=` have no counterpart there and are dropped.
 */
const ThreatsToSignals = ({ base }) => {
  const { search } = useLocation();
  const severity = new URLSearchParams(search).get('severity');
  const sev = severity && severity !== 'all' ? `?sev=${encodeURIComponent(severity)}` : '';
  return <Navigate to={`${base}/security/signals${sev}`} replace />;
};

export default ThreatsToSignals;
